import * as Helper from '../helpers/helper';
import axios from 'axios';

export default class GetTickets {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        if (document.getElementsByClassName('get-tickets-section')[0]) {
            this.getTickets();
        }
    }

    getTickets() {
        event.preventDefault();
        let lang = Helper.getCurrentLang();
        let form = document.getElementById('get-tickets-input');
        let validate_btn_loader = document.getElementById('get-tickets-button-loader');
        let validate_btn_text = document.getElementById('get-tickets-button-text');
        let validate_btn_validate = document.getElementById('get-tickets-validate');

        let referenceCode = document.getElementsByClassName('reference-code')[0];
        let organizerName = document.getElementsByClassName('organizer')[0];
        let eventName = document.getElementsByClassName('event-name')[0];
        let eventDate = document.getElementsByClassName('event-date')[0];
        let bookingDate = document.getElementsByClassName('booking-date')[0];
        let email = document.getElementsByClassName('email')[0];

        let bookingInfos = document.getElementsByClassName('booking-infos')[0];

        this.referenceCode = null;

        this.notifSuccess = document.querySelector('#ticket-success');
        this.notifError = document.querySelector('#ticket-error');
        this.explanation = this.notifError.querySelector('.description');
        this.ikeLoader = document.getElementById('ike-loader');

        if (form) {
            // step 1 : get tickets infos
            form.addEventListener('submit', (event) => {
                event.preventDefault();

                grecaptcha.ready(() => {
                    grecaptcha.execute(window.portal_conf.RECAPTCHA_V3_SITE_KEY, {
                        action: 'submit'
                    }).then((token) => {
                        if (token) {
                            const ticketInput = document.querySelector('input[name="ticketInput"]').value;
                            this.ikeLoader.classList.remove('hidden');

                            axios.post(`/${lang}/get-tickets-infos`, {
                                ticketInput: ticketInput,
                                recaptcha_response: token
                            }).then((response) => {
                                this.ikeLoader.classList.add('hidden');

                                if (response.data.successScore === false) {
                                    this.notifSuccess.style.display = 'none';
                                    this.explanation.innerHTML = `${response.data.errorMessage}`;
                                    Helper.displayNotification(this.notifError);
                                } else {
                                    this.referenceCode = response.data.reservation.reference_code;
                                    referenceCode.innerHTML = response.data.reservation.reference_code;
                                    organizerName.innerHTML = response.data.reservation.organizer;
                                    if (response.data.reservation.event_name) {
                                        eventName.innerHTML = response.data.reservation.event_name;
                                    } else {
                                        eventName.parentElement.style.display = 'none';
                                    }
                                    if (response.data.reservation.event_date) {
                                        eventDate.innerHTML = response.data.reservation.event_date;
                                    } else {
                                        eventDate.parentElement.style.display = 'none';
                                    }
                                    bookingDate.innerHTML = response.data.reservation.command_date;
                                    email.innerHTML = response.data.reservation.email;

                                    bookingInfos.style.display = 'block';
                                }
                            }).catch((error) => {
                                this.ikeLoader.classList.add('hidden');
                                if (error.response?.status == 429) {
                                    this.notifSuccess.style.display = 'none';
                                    this.explanation.innerHTML = window.jsTranslations['get_tickets_too_many_request'];
                                    Helper.displayNotification(this.notifError);
                                } else {
                                    this.notifSuccess.style.display = 'none';
                                    this.explanation.innerHTML = window.jsTranslations['basic_error_message'];
                                    Helper.displayNotification(this.notifError);
                                }
                            });
                        }
                    });
                });
            });

            // step 2 : send email
            validate_btn_validate.addEventListener('click', () => {
                validate_btn_text.style.display = 'none';
                validate_btn_loader.classList.remove('hidden');
                this.notifSuccess.style.display = 'none';
                this.notifError.style.display = 'none';

                grecaptcha.ready(async () => {
                    const token = await grecaptcha.execute(window.portal_conf.RECAPTCHA_V3_SITE_KEY, {
                        action: 'submit'
                    });

                    if (!token) {
                        validate_btn_text.style.display = 'block';
                        validate_btn_loader.classList.add('hidden');
                        this.explanation.innerHTML = window.jsTranslations['basic_error_message'];
                        Helper.displayNotification(this.notifError);
                        return;
                    }

                    axios.post(`/${lang}/send-email`, {
                        ticketInput: this.referenceCode,
                        recaptcha_response: token
                    }).then((response) => {
                        if (response.data.success === false) {
                            this.explanation.innerHTML = `${response.data.errorMessage}`;
                            Helper.displayNotification(this.notifError);
                        } else {
                            this.explanation.innerHTML = '';
                            Helper.displayNotification(this.notifSuccess);
                        }
                    }).catch((error) => {
                        if (error.response?.status === 429) {
                            this.explanation.innerHTML = window.jsTranslations['get_tickets_too_many_request'];
                            Helper.displayNotification(this.notifError);
                        } else {
                            this.explanation.innerHTML = window.jsTranslations['basic_error_message'];
                            Helper.displayNotification(this.notifError);
                        }
                    }).finally(() => {
                        validate_btn_text.style.display = 'block';
                        validate_btn_loader.classList.add('hidden');
                    });
                });
            });
        }
    }
}
